<template>
  <v-container id="pedidos" tag="section">
    <base-v-component heading="Pedidos internos " />
    <base-material-card color="indigo" icon="mdi-account-multiple" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="internos"
        :loading="loading"
        :search="search"
        :must-sort="true"
        sort-by="fecha"
        :sort-desc="true"
      >
        <template v-slot:item.acciones="{ item }">
          <v-row>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="green"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goView(item)"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Ver pedido {{item.id}}</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import firebase from "firebase";

export default {
  data() {
    return {
      loadingRefund: false,
      loading: false,
      search: "",
      headers: [
        {
          sortable: false,
          text: "Pedido Restaurante",
          value: "id"
        },
        {
          sortable: false,
          text: "Fecha",
          value: "fechaEspera"
        },
        {
          sortable: false,
          text: "Restaurante",
          value: "restaurante"
        },
        {
          sortable: false,
          text: "Estado",
          value: "estado"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      internosState: state => state.internos.pedidos
    }),
    ...mapGetters({
      pedidosGetter: "internos/getPedidosListadoRestaurante"
    }),
    internos() {
      var iter = this.internosState;
      return iter.map(r => {
        console.log(r);
        const aux = r.fechaEspera;
        r.fechaEspera = moment(aux.toDate()).format("d/MM/YYYY HH:mm");
        return r;
      });
    }
  },
  methods: {
    reload() {
      this.getPedidos();
    },
    getPedidos() {
      this.loading = true;
      let _vm = this;
      return this.$store
        .dispatch("internos/getPedidosInternosRestaurante")
        .finally(() => {
          _vm.loading = false;
        });
    },
    goView(item) {
      alert("por implementar");
      /*let str = "/admin/pedidos/view/" + item.id;
      this.$router.push(str);*/
    }
  },
  mounted() {}
};
</script>

<style>
</style>